import styled from 'styled-components/macro';
import { sizePalette } from 'utils/styleConstants';

export const LeftArrow = styled.img<{ disabled: boolean }>`
  position: absolute;
  left: 0px;
  top: 10px;
  cursor: pointer;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  color: ${({ disabled, theme }) => (disabled ? theme.colorPalette.grey.grey4 : theme.colorPalette.turquoise.normal)};
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: ${({ theme }) => theme.fontWeightPalette.bold};
`;

export const RightArrow = styled.img<{ disabled: boolean }>`
  position: absolute;
  right: 0px;
  top: 10px;
  cursor: pointer;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  color: ${({ disabled, theme }) => (disabled ? theme.colorPalette.grey.grey4 : theme.colorPalette.turquoise.normal)};
  font-family: ${({ theme }) => theme.fontFamily};
  font-weight: ${({ theme }) => theme.fontWeightPalette.bold};
`;

export const Container = styled.div<{ hasBorder?: boolean }>`
  position: relative;
`;

export const TabList = styled.div<{ width?: string }>`
  display: flex;
  overflow: hidden;
  box-sizing: border-box;
`;

export const TabPanels = styled.div<{ maxHeight?: string; hasBorder?: boolean; padding?: string; minWidth?: string }>`
  ${({ minWidth }) => minWidth && `min-width:${minWidth}`};
  border: ${({ theme, hasBorder }) => (hasBorder ? `1px solid ${theme.colorPalette.grey.grey5}` : '')};
  border-radius: 1px;
  padding: ${({ padding }) => padding || '10px 6px'};
  width: 100%;
  overflow-y: auto;
  max-height: ${(props) => props.maxHeight};
  overflow-x: hidden;
`;

export const TabContainer = styled.div<{
  disabled?: boolean;
  isSelected: boolean;
  singleTabWidth?: string;
}>`
  width: ${(props) => (props.singleTabWidth ? `${props.singleTabWidth}%` : sizePalette.size.full)};
  margin-right: ${sizePalette.spacing[1]};
  margin-bottom: ${sizePalette.spacing[1.5]};
  padding: ${sizePalette.spacing[0]} ${sizePalette.spacing[5]};
  border-bottom: ${sizePalette.spacing[1.5]} solid
    ${({ theme }) =>
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent2 : theme.colorPalette.turquoise.accent2};

  ${({ disabled, theme }) =>
    disabled &&
    `
    pointer-events: none;
    border-bottom: ${sizePalette.spacing[1.5]} solid ${
      theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey8 : theme.colorPalette.grey.grey3
    };
  `}

  ${({ isSelected, theme }) =>
    isSelected &&
    `
    border-bottom: ${sizePalette.spacing[1.5]} solid ${
      theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark
    };
    border-radius: ${sizePalette.borderRadius.none};
  `}

  button {
    font-family: ${({ theme }) => theme.fontFamily};
    color: ${({ theme }) => theme.colorPalette.grey.grey9};
    font-size: ${({ theme }) => theme.fontSizePalette.xSmall};
    line-height: ${sizePalette.lineHeight.none};
    letter-spacing: ${sizePalette.letterSpacing.widest};
    cursor: pointer;
    width: ${sizePalette.size.full};
    background: transparent;
    border: ${sizePalette.borderWidth[0]};
    white-space: nowrap;
    ${({ isSelected, theme }) =>
      isSelected &&
      `
      color: ${theme.colorPalette.isDarkMode ? theme.colorPalette.turquoise.accent : theme.colorPalette.turquoise.dark};
      font-weight: ${theme.fontWeightPalette.bold};
    `}
    ${({ disabled, theme }) =>
      disabled &&
      `
      color: ${theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey8 : theme.colorPalette.grey.grey5};
      cursor: not-allowed;
    `}

    &:focus {
      outline: none;
      border: ${sizePalette.borderWidth[0]};
    }
  }
`;

export const PanelDescription = styled.div`
  margin-bottom: ${sizePalette.spacing[4]};
  padding: ${sizePalette.spacing[3]};
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSizePalette.small};
  line-height: ${sizePalette.lineHeight.relaxed};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  border-radius: ${sizePalette.borderRadius.sm};
`;
